import React from 'react'
import { Text, Checkbox, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  ProductCarouselItem,
  ProductCarouselItemTitle,
  ProductCarouselImage,
  ProductCarouselItemPrice,
} from '@/checkout-instore-legacy/components/ProductCarousel'
import { getCurrencyCode } from '@/checkout-instore-legacy/utils/PaymentUtils'
import { useMediaQuery } from '@/checkout-instore-legacy/hooks/mediaQuery'
import { getPriceInfo } from './utils'
import { ShowTogetherItem } from '@/checkout-instore-legacy/product/typings'

export type ShowTogetherProductsItemProps = {
  item: ShowTogetherItem
  isChecked?: boolean
  isMainItem: boolean
  handleItemClick: () => void
}

export const ShowTogetherProductsItem = ({
  item,
  isMainItem,
  isChecked,
  handleItemClick,
}: ShowTogetherProductsItemProps) => {
  const currencyCode = getCurrencyCode() ?? 'BRL'

  const { value: isDesktop } = useMediaQuery({
    phone: false,
    tablet: false,
    desktop: true,
  })

  const { price } = getPriceInfo(item)

  return (
    <ProductCarouselItem onClick={handleItemClick}>
      <div className={csx({ position: 'relative' })}>
        <div
          className={csx({
            position: 'absolute',
            top: '0.625rem',
            display: 'flex',
            width: '100%',
            paddingX: '$space-2',
            justifyContent: 'space-between',
            zIndex: '999',
          })}
        >
          <Checkbox
            data-testid={`show-together-products-item-${item.id}`}
            disabled={!price}
            checked={isChecked}
          />
          {isMainItem && (
            <div
              className={csx({
                marginLeft: '$space-2',
                padding: '$space-05',
                paddingX: '$space-1',
                alignItems: 'center',
                borderRadius: '$base',
                background: '$white',
              })}
            >
              <Text
                variant="detail"
                tone="primary"
                className={csx({
                  '@desktop': {
                    text: '$action2',
                  },
                })}
              >
                {isDesktop ? (
                  <FormattedMessage id="showTogether.mainProductLabelDesktop" />
                ) : (
                  <FormattedMessage id="showTogether.mainProductLabel" />
                )}
              </Text>
            </div>
          )}
        </div>
        <ProductCarouselImage
          src={item.images[0]}
          alt={item.name}
          sizeInPx={300}
        />
      </div>
      <ProductCarouselItemTitle title={item.name}>
        {item.name}
      </ProductCarouselItemTitle>
      <ProductCarouselItemPrice
        currencyCode={currencyCode}
        isBusy={false}
        purchaseConditionsPrices={item.purchaseCondition}
      />
    </ProductCarouselItem>
  )
}
